import { SupportedChainId } from '~/constants/chains'
import { useDisplayName } from '~/hooks/useDisplayName'
import { usePrivacyMode } from '~/hooks/usePrivacyMode'
import { HIDDEN_ADDRESS } from '~/store/privacyModeStore'
import { IAddress } from '~/types'
import { shortenAddress, shortenENS } from '~/utils/addresses'
import { cn } from '~/utils/tailwind-utils'

export const ShortenedEnsOrAddress = ({
  address,
  chainId,
  expand = false,
}: {
  address: IAddress
  chainId?: SupportedChainId
  expand?: boolean
}) => {
  const { ens } = useDisplayName(address, chainId)
  const isPrivacyModeOn = usePrivacyMode()
  if (isPrivacyModeOn) {
    return <span className="min-w-0 truncate">{HIDDEN_ADDRESS}</span>
  }
  return (
    <span
      className={cn('min-w-0 truncate', {
        'w-full': expand,
      })}
    >
      <span>
        {ens
          ? shortenENS(ens)
          : shortenAddress(address, expand ? 10 : 4, expand ? 10 : 4)}
      </span>
    </span>
  )
}
